import { render, staticRenderFns } from "./StatusOferta.vue?vue&type=template&id=652cbc3e&scoped=true&"
import script from "./StatusOferta.vue?vue&type=script&lang=js&"
export * from "./StatusOferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652cbc3e",
  null
  
)

export default component.exports